module.exports = __webpack_public_path__ + "media/images/about/ac_3-835a0fdc076463334ccf222228a1a523.jpg";